import React from 'react'

const ChevronDown = ({ size = 14, color = '#161616', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size * 8) / 14} 
    viewBox="0 0 14 8"
    fill="none"
    {...props}
  >
    <path
      d="M1 1L7 7L13 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ChevronDown;
